import styled from "styled-components";

import { desktopMedia } from "app/pages/sales-intelligence/modules/manage-integrations/containers/styles";

const CARD_GAP = 24;

export const StyledCardsWrapperContent = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${CARD_GAP}px;

    & > * {
        box-sizing: border-box;
        min-width: 0;
    }

    ${desktopMedia`
        grid-template-columns: repeat(4, 1fr);
    `}
`;
